import * as requestFromServer from "./recapitulationReportCrud";
import {
  superAdminRecapitulationReportSlice,
  callTypes
} from "./recapitulationReportSlice";
import { actions as auth } from "../../../Auth/_redux/authRedux";
import { toastOption } from "../../../../../_metronic/_helpers/ToastHelpers";
import { toast } from "react-toastify";

const { actions } = superAdminRecapitulationReportSlice;

export const fetchRecapitulationReports = queryParams => dispatch => {
  dispatch(actions.startCall({ callType: callTypes.list }));
  return requestFromServer
    .findRecapitulationReport(queryParams)
    .then(response => {
      const {
        data: { total_items, items }
      } = response.data;
      dispatch(actions.recapitulationReportsFetched({ total_items, items }));
    })
    .catch(error => {
      // if (error.response.status === 401) {
      //   toast.error(error.response.data.message, toastOption);
      //   dispatch(auth.logout());
      // }
      // error = error.response.data.message;
      dispatch(actions.catchError({ error, callType: callTypes.list }));
    });
};